import { combineReducers } from '@reduxjs/toolkit'

import currentPurchase from './currentPurchaseSlice'

const reducer = combineReducers({
    currentPurchase,
})

export default reducer
